export const INVALID_COUPON_ERROR_CODE = 1100;

export const BOOKING_ERROR_MESSAGES = {
    703 : "Dieses Produkt ist leider ausverkauft.",
    803 : "Für diesen Termin sind leider keine Plätze mehr verfügbar.",
    804 : "Du hast kein gültiges Abo für diese Buchung.",
    805 : "Diese Buchung ist bereits abgeschlossen.",
    806 : "Dieser Termin wurde abgesagt.",
    807 : "Für diesen Kurs benötigst du eine Freischaltung – bitte melde dich bei uns.",
    908 : "Diese Zahlungsmethode ist für dieses Produkt leider nicht verfügbar (nur für Euro-Produkte).",
    912 : "Diese Zahlungsmethode ist für dieses Produkt leider nicht verfügbar (nur für Euro- und Pfund-Produkte).",
    913 : "Die Zahlung wurde nicht abgeschlossen. Bitte versuche es erneut oder wähle eine andere Zahlungsmethode.",
};
